import Colors from "../AppColors"

export const OrderStatus = {
    inProgress: 'In progress',
    received: 'Received',
    confirmed: 'Confirmed',
    intransit: 'Intransit',
    completed: 'Completed',
    cancelled: 'Cancelled',
    unfulfilled: 'Unfulfilled',
    unacknowledged: 'Unacknowledged'
}

export const OrderStatusTitle = {
    [OrderStatus.inProgress]: 'Order has been shared with store',
    [OrderStatus.received]: 'Price received from the store',
    [OrderStatus.confirmed]: 'Order will be dispatched soon',
    [OrderStatus.intransit]: 'Order out for delivery',
    [OrderStatus.completed]: 'Order Delivered',
    [OrderStatus.cancelled]: 'Order Cancelled',
    [OrderStatus.unfulfilled]: 'Order will be dispatched soon',
    [OrderStatus.unacknowledged]: 'Order cancelled'
}

export const OrderStatusColor = {
    [OrderStatus.inProgress]: Colors.orange.activityStatus,
    [OrderStatus.received]: Colors.green.primary,
    [OrderStatus.confirmed]: Colors.orange.activityStatus,
    [OrderStatus.intransit]: Colors.black,
    [OrderStatus.completed]: Colors.green.primary,
    [OrderStatus.cancelled]: Colors.grey.fillerInfo,
    [OrderStatus.unfulfilled]: Colors.black,
    [OrderStatus.unacknowledged]: Colors.grey.fillerInfo
}

export const OrderStatusIcon = {
    [OrderStatus.inProgress]: '/images/icons/orderStatus/in_progress.svg',
    [OrderStatus.received]: '/images/icons/orderStatus/received.svg',
    [OrderStatus.confirmed]: '/images/icons/orderStatus/confirmed.svg',
    [OrderStatus.intransit]: '/images/icons/orderStatus/dispatched.svg',
    [OrderStatus.completed]: '/images/icons/orderStatus/completed.svg',
    [OrderStatus.cancelled]: '/images/icons/orderStatus/cancel.svg',
    [OrderStatus.unfulfilled]: '/images/icons/orderStatus/confirmed.svg',
    [OrderStatus.unacknowledged]: '/images/icons/orderStatus/cancel.svg',
}

export const OrderStatusDescription = {
    [OrderStatus.inProgress]: 'We will notify you once a chemist store responds.',
    [OrderStatus.received]: 'Store has shared the price with you. To proceed with your order please confirm',
    [OrderStatus.confirmed]: 'Chemist store is currently putting your order together',
    [OrderStatus.intransit]: 'Your order has been dispatched & will be reach you soon. You can call or message the store directly.',
    [OrderStatus.completed]: '',
    [OrderStatus.cancelled]: '',
    [OrderStatus.unfulfilled]: '',
    [OrderStatus.unacknowledged]: ''
}

export const omsPharmacyStatusMap = {
    1: 'In progress',
    2: 'Offer sent',
    3: 'Offer declined',
    4: 'Accepted',
    5: 'Cancelled',
    6: 'Order delivered',
    7: 'Not delivered',
    8: 'Declined',
    9: 'Confirmed with other store'
}

export const OrderStatusMap = { // Depend upon pharmacy status
    1: {
        // order status depend upon pharmacy status
        // omsPharmacyStatusMap
        1: OrderStatus.inProgress,
        2: OrderStatus.received,
        3: OrderStatus.cancelled,
        8: OrderStatus.cancelled
    },
    2: OrderStatus.confirmed,
    3: OrderStatus.completed,
    4: OrderStatus.cancelled,
    5: OrderStatus.unfulfilled,
    6: {
        // order status depend upon pharmacy status
        // omsPharmacyStatusMap
        6: OrderStatus.intransit,
        7: OrderStatus.unacknowledged,
        9: OrderStatus.cancelled
    },
}


export const ActiveOrderStatus = [
    OrderStatus.inProgress, OrderStatus.received, OrderStatus.confirmed,
    OrderStatus.intransit, OrderStatus.unfulfilled]

export const ClosedOrderStatus = [
    OrderStatus.unacknowledged, OrderStatus.completed, OrderStatus.cancelled]

export const CompleteOrderStatus = [OrderStatus.completed]

export const CancelOrderStatus = [OrderStatus.unacknowledged, OrderStatus.cancelled]